const API_BASE_URL=process.env.REACT_APP_API_BASE_URL
const {fetchApi} = require('../apiHelper');

// Load spots by location
async function httpGetSpotsByLocation(lat, lon) {
  
    const response = await fetchApi(`${API_BASE_URL}/surfspots/`);
  
    return await response.json();
    
  }
  
// Load spot by id
async function httpGetSpotById(spotId) {
  const response = await fetchApi(`${API_BASE_URL}/surfspots/` + spotId );
  return await response.json();
}

export {
    httpGetSpotsByLocation,
    httpGetSpotById,
  };